import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useUploadMeetingTranscriptMutation(meetingId: string) {
    const queryClient = useQueryClient();
    const { project } = useProject();
    return useMutation({
        mutationFn: async (transcript: string) => {
            await apiClient.uploadMeetingTranscript({
                params: {
                    meetingId,
                },
                body: {
                    transcript: transcript,
                },
            });
        },
        onSuccess: async () => {
            await queryClient.refetchQueries({
                queryKey: ["project", project.id, "meetings"],
            });
        },
    });
}
